const channel =
  "BroadcastChannel" in window ? new BroadcastChannel("glides") : null;

export type BroadcastMessage =
  | { type: "change-light-mode" }
  | { type: "refresh-beta-features" }
  | { type: "refresh-pending-changes"; key: string };

/**
 * @param callback message handler
 * @returns unsubscribe function
 */
export const handleBroadcast = (
  callback: (message: BroadcastMessage) => void,
): (() => void) => {
  const listener = (event: MessageEvent<BroadcastMessage>) => {
    callback(event.data);
  };
  channel?.addEventListener("message", listener);
  return () => {
    channel?.removeEventListener("message", listener);
  };
};

export const broadcastMessage = (message: BroadcastMessage) => {
  channel?.postMessage(message);
};
